
export enum EcmSummaryCountTypeCd {
	LIFETIME = 'Lifetime'}

